import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SupplierCard = ({ supplier, onEdit, onDelete, onViewDetails }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'excellent':
        return 'bg-success/10 text-success';
      case 'good':
        return 'bg-primary/10 text-primary';
      case 'warning':
        return 'bg-warning/10 text-warning';
      case 'critical':
        return 'bg-error/10 text-error';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'excellent':
        return 'CheckCircle2';
      case 'good':
        return 'CheckCircle';
      case 'warning':
        return 'AlertTriangle';
      case 'critical':
        return 'XCircle';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6 hover:shadow-lg transition-all">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="User" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-base md:text-lg font-semibold text-foreground">{supplier?.name}</h3>
            <p className="text-xs md:text-sm text-muted-foreground">{supplier?.farmerId}</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onEdit(supplier)}
            iconName="Edit"
            iconSize={18}
          >
            <span className="sr-only">Edit</span>
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onDelete(supplier?.id)}
            iconName="Trash2"
            iconSize={18}
          >
            <span className="sr-only">Hapus</span>
          </Button>
        </div>
      </div>
      <div className="space-y-3 mb-4">
        <div className="flex items-center gap-2">
          <Icon name="MapPin" size={16} color="var(--color-muted-foreground)" />
          <span className="text-sm text-foreground">{supplier?.location}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Volume Harian:</span>
          <span className="text-sm font-medium text-foreground data-text">{supplier?.dailyVolume} L</span>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2 mb-4">
        <div className="text-center">
          <div className={`inline-flex items-center gap-1 px-2 py-1 rounded-lg ${getStatusColor(supplier?.qualityStatus)} mb-1`}>
            <Icon name={getStatusIcon(supplier?.qualityStatus)} size={12} />
            <span className="text-xs font-medium">{supplier?.qualityRating}%</span>
          </div>
          <p className="text-xs text-muted-foreground">Kualitas</p>
        </div>
        <div className="text-center">
          <div className={`inline-flex items-center gap-1 px-2 py-1 rounded-lg ${getStatusColor(supplier?.paymentStatus)} mb-1`}>
            <Icon name={supplier?.paymentStatus === 'excellent' ? 'CheckCircle2' : 'Clock'} size={12} />
            <span className="text-xs font-medium capitalize">{supplier?.paymentLabel}</span>
          </div>
          <p className="text-xs text-muted-foreground">Pembayaran</p>
        </div>
        <div className="text-center">
          <div className={`inline-flex items-center gap-1 px-2 py-1 rounded-lg ${getStatusColor(supplier?.consistencyStatus)} mb-1`}>
            <Icon name={getStatusIcon(supplier?.consistencyStatus)} size={12} />
            <span className="text-xs font-medium">{supplier?.consistencyScore}%</span>
          </div>
          <p className="text-xs text-muted-foreground">Konsistensi</p>
        </div>
      </div>
      <Button
        variant="outline"
        fullWidth
        onClick={() => onViewDetails(supplier)}
        iconName="Eye"
        iconPosition="left"
      >
        Lihat Detail
      </Button>
    </div>
  );
};

export default SupplierCard;